/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {diplomatObjectSchema} from './diplomat-object';
import {enums} from './enums';

export const PasswordData = diplomatObjectSchema.shape({
   passwordUpdateInterval: yup.string().oneOf(enums.passwordUpdateInterval.keys),
   minNumChars: yup.string(),
   mixedCaseRequired: yup.boolean(),
   alphaNumericRequired: yup.boolean(),
   specialCharsRequired: yup.boolean(),
});
export type IPasswordData = yup.InferType<typeof PasswordData>;

export const ChangePassword = yup.object({
   currentPassword: yup.string(),
   newPassword: yup.string(),
   newPassword2: yup
      .string()
      .oneOf([yup.ref('newPassword'), null])
      .required('Password confirm is required'),
   passwordData: PasswordData.clone().optional(),
});
export type IChangePassword = yup.InferType<typeof ChangePassword>;
